<xpo-shell class="app-tariff-container">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name>{{ title }}</xpo-header-sub-app-name>
  <xpo-header-utilities-actions>
    <xpo-auth-user-profile class="profile-pic"></xpo-auth-user-profile>
  </xpo-header-utilities-actions>
  <xpo-header-navigation>
    <ng-container *ngFor="let route of userRoutes$ | async; let i = index">
      <button [routerLink]="route.path" routerLinkActive="xpo-selected">
        {{ route.label }}
      </button>
    </ng-container>
  </xpo-header-navigation>
  <router-outlet></router-outlet>
</xpo-shell>
<xpo-footer xpoFooterSticky [version]="build">
  <div>
    <a xpo-regular-link href="mailto: {{ email }}" color="accent">Feedback</a>
  </div>
</xpo-footer>
